// extracted by mini-css-extract-plugin
export default {"productDescription":"X--z","featuredDescription":"Y--z","description":"Z--z","more":"_--z","descriptionSku":"a_-z"};